<div class="bg-primary nav-bar">
    <div class="container">

        <nav id="nav1">
            <div class="n1-wrap">
                <div class="display-left-border"><a class="menuItem" id="titleCourseware"
                        [routerLink]="['/coursewareview']" [style.font-weight]="isFoundationsOfLawActive()">Foundations
                        of Law</a></div>
                <div class="display-left-border"><a class="menuItem" id="titleVideos"
                        [routerLink]="['/shortvideosview']" [style.font-weight]="isShortVideosActive()">Short-Videos</a>
                </div>
                <div class="display-left-border" style="width: 194px">
                    <a class="menuItemWithDescription" id="titleVideocourses" [routerLink]="['/videocoursesview']"
                        [style.font-weight]="isVideoCoursesActive()">Video-Courses
                        <span class="menuItemDescription">EARN A CREDENTIAL!</span>
                    </a>
                </div>
                <div class="display-both-borders"><a class="menuItem" id="titleResearchIndex"
                        [routerLink]="['/researchindexview']" [style.font-weight]="isResearchIndexActive()">Research
                        Index
                    </a>
                </div>

                <div class="form-group">
                    <label>Search:</label>
                    <div class="input-icon" style="width: 160px">
                        <input onkeyup="if (event.which === 13) {performSearch();}" style="background-color: #b0cccb;"
                            id="SiteSearchInput" name="SiteSearchInput" title="Search LawShelf" type="text">
                        <a onclick="performSearch()" class="fa fa-search"></a>
                    </div>
                </div>
            </div>
        </nav>
        <div class="row">
            <div class="mobi-nav-wrap" style="width: 100%; margin-left: 0px !important; margin-right: 0px !important">
                <nav class="navbar main-nav mobi-nav">
                    <div *ngIf="!getUserName()" class="mobi-subtitle" style="color: green; background-color: #6ca3a1">
                        <a class="btn login-register-buttons margin-right-5 margin-bottom-5"
                            [routerLink]="['/loginview']"><i class="fa fa-user login-register-text"
                                aria-hidden="true"></i> Log in </a>
                    </div>
                    <div *ngIf="getUserName()" class="mobi-subtitle" style="color: green; background-color: #6ca3a1">
                        <a class="btn login-register-buttons margin-right-5 margin-bottom-5" [routerLink]=""
                            (click)="doLogout()"><i class="fa fa-sign-out margin-left-10" aria-hidden="true"></i>Log
                            out</a>
                        <a class="btn login-register-buttons margin-right-5 margin-bottom-5"
                            [routerLink]="['/accountview']"><i class="fa fa-user" aria-hidden="true"></i>My Account</a>
                    </div>
                    <button id="navbarHamburgerButton" style="text-align: right !important" class="navbar-toggler"
                        type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
                        aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                        <i class="fa fa-bars" style="color: white; font-size: 26px" aria-hidden="true"></i>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                        <div class="myblock">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="centerBlock">
                                        <a id="titleCourseware" [routerLink]="['/coursewareview']"
                                            routerLinkActive="active">Foundations of Law</a>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="centerBlock">
                                        <a data-target=".navbar-collapse" id="titleVideos"
                                            [routerLink]="['/shortvideosview']"
                                            routerLinkActive="active">Short-Videos</a>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="centerBlock">
                                        <a id="titleVideocourses" [routerLink]="['/videocoursesview']"
                                            routerLinkActive="active">Video-Courses<br>
                                            <span class="menuItemDescription">EARN A CREDENTIAL!</span>
                                        </a>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="centerBlock">
                                        <a id="titleResearchIndex" [routerLink]="['/researchindexview']"
                                            routerLinkActive="active">Research
                                            Index</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</div>